import { render, staticRenderFns } from "./im-system.vue?vue&type=template&id=77739a6b&scoped=true"
import script from "./im-system.vue?vue&type=script&lang=js"
export * from "./im-system.vue?vue&type=script&lang=js"
import style0 from "./im-system.vue?vue&type=style&index=0&id=77739a6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77739a6b",
  null
  
)

export default component.exports